import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "show", "hide"]
  static values = { showValue: String }

  connect() {
    this.toggle()
  }

  toggle(event) {
    const value = (event && event.target && event.target.value) || this.currentValue()
    if (!value ) return

    const showValue = this.hasShowValueValue ? this.showValueValue : "1"
    const shouldShow = value.toString() === showValue

    this.updateGroups(this.showTargets, shouldShow)
    this.updateGroups(this.hideTargets, !shouldShow)
  }

  currentValue() {
    if (!this.hasTriggerTarget) return null

    const source = this.triggerTarget

    if (source.matches && source.matches("input, select, textarea")) {
      return source.value
    }

    const checked = source.querySelector("input[type='radio']:checked")
    return checked ? checked.value : null
  }

  updateGroups(targets, show) {
    targets.forEach((group) => {
      group.classList.toggle("tw-hidden", !show)
      group.setAttribute("aria-hidden", (!show).toString())
      this.toggleInputs(group, show)
    })
  }

  toggleInputs(group, enable) {
    group.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !enable
    })
  }
}
